import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import useTime from '../../../common/hook/time';
const Container = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  gap: clamp(0.14rem, 0.18vw, 0.18rem);
  margin-top: 1rem;
  text-align: right;
  font-family: 'Sora', sans-serif;
`;
const DateText = styled.div `
  color: rgba(181, 190, 202, 0.88);
  font-size: clamp(0.56rem, 0.62vw, 0.64rem);
  font-weight: 400;
  line-height: 1.2;
  max-width: clamp(10rem, 18vw, 18rem);
  overflow-wrap: anywhere;
`;
const TimeText = styled.div `
  color: #f4f7fb;
  font-size: clamp(0.98rem, 1.08vw, 1.12rem);
  font-weight: 700;
  line-height: 1.05;
  white-space: nowrap;
  letter-spacing: -0.01em;
`;
const FloorTimeDisplay = () => {
    const { time, dateLabel } = useTime();
    return (_jsxs(Container, { children: [_jsx(DateText, Object.assign({ title: dateLabel }, { children: dateLabel })), _jsx(TimeText, { children: time })] }));
};
export default FloorTimeDisplay;
